export default "__VITE_ASSET__3087d092__"